import light from '../assets/images/patt-light.jpg';
import dark from '../assets/images/patt-dark.jpg';

export {
  colors,
  cardBadges,
  cardImages,
  cardsCopyStack,
  cardBackgrounds,
} from './cardOptions';

export const backgrounds = [dark, light];

export const channelIcons = {
  etsy: {
    iconSize: 86,
    contentSize: 28,
    name: 'etsy',
  },
  woo: {
    iconSize: 71,
    contentSize: 28,
    name: 'woo',
  },
  amazon: {
    iconSize: 71,
    contentSize: 28,
    name: 'amazon',
  },
  square: {
    iconSize: 47,
    contentSize: 28,
    name: 'square',
  },
  shopify: {
    iconSize: 83,
    contentSize: 38,
    name: 'shopify',
  },
  ebay: {
    iconSize: 71,
    contentSize: 28,
    name: 'ebay',
  },
  squarespace: {
    iconSize: 54,
    contentSize: 28,
    name: 'squarespace',
  },
};

export const productColors = [
  {
    color: '#FFFFFF',
    name: 'White',
    price: '$15.99',
  },
  {
    color: '#009B8A',
    name: 'Lime green',
    price: '$16.99',
  },
  {
    color: '#B23665',
    name: 'Rouge',
    price: '$17.99',
  },
];
